document.addEventListener('DOMContentLoaded', function() {
    const partnersBlocks = document.querySelectorAll('.wcl-clients-block');
    
    partnersBlocks.forEach(block => {
        const loadMoreBtn = block.querySelector('.wcl-clients-block__load-more');
        const partnersWrapper = block.querySelector('.wcl-clients-block__partners');
        const loader = block.querySelector('.wcl-clients-block__loader');
        
        if (!loadMoreBtn) return;
        
        let currentPage = 1;
        
        loadMoreBtn.addEventListener('click', function() {
            currentPage++;
            
            loader.style.display = 'flex';
            partnersWrapper.style.opacity = '0.5';
            
            const formData = new FormData();
            formData.append('action', 'load_more_partners');
            formData.append('page', currentPage);
            formData.append('nonce', config.nonce);
            
            fetch(config.ajax_url, {
                method: 'POST',
                credentials: 'same-origin',
                body: formData
            })
            .then(response => {
                return response.json();
            })
            .then(data => {
                if (data.success) {
                    partnersWrapper.insertAdjacentHTML('beforeend', data.data.html);
                    
                    if (!data.data.has_more) {
                        loadMoreBtn.style.display = 'none';
                    }
                }
                loader.style.display = 'none';
                partnersWrapper.style.opacity = '1';
            })
            .catch(error => {
                console.error('Fetch error:', error);
                loader.style.display = 'none';
                partnersWrapper.style.opacity = '1';
            });
        });
    });
});